var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SocialAuthBtn',{staticClass:"wechat-btn",attrs:{"img":_vm.logo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithWeChat'),"color":"#00dd6c","tiny":_vm.tiny},on:{"click":_vm.weChatLogIn}})}
var staticRenderFns = []

export { render, staticRenderFns }